import Cropper from 'cropperjs';

class ImageCropperModal {
    constructor() {
        this.modal = document.getElementById('cropModal');
        this.cropperImage = document.getElementById('cropperImage');
        this.closeBtn = document.querySelector('.close-modal');
        this.cancelBtn = document.getElementById('cancelCrop');
        this.cropBtn = document.getElementById('cropImage');
        this.cropper = null;
        
        this.bindEvents();
    }

    bindEvents() {
        window.addEventListener('click', (e) => {
            if (e.target === this.modal) {
                this.close();
            }
        });

        this.closeBtn.addEventListener('click', () => this.close());
        this.cancelBtn.addEventListener('click', () => this.close());

        this.cropBtn.addEventListener('click', () => this.handleCrop());
    }

    open(imageUrl, previewImage) {
        this.previewImage = previewImage;
        this.cropperImage.src = imageUrl;
        this.modal.style.display = 'block';
        
        if (this.cropper) {
            this.cropper.destroy();
        }
        
        this.cropper = new Cropper(this.cropperImage, {
            aspectRatio: 1,
            viewMode: 1,
            dragMode: 'move',
            autoCropArea: 1,
            restore: false,
            guides: true,
            center: true,
            highlight: false,
            cropBoxMovable: true,
            cropBoxResizable: true,
            toggleDragModeOnDblclick: false,
        });
    }

    close() {
        if (this.modal) {
            this.modal.style.display = 'none';
        }

        if (this.cropper) {
            this.cropper.destroy();
            this.cropper = null;
        }
    }

    handleCrop() {
        if (!this.cropper || !this.previewImage) return;

        const canvas = this.cropper.getCroppedCanvas({
            width: 1600,
            height: 1600
        });

        canvas.toBlob((blob) => {
            const url = URL.createObjectURL(blob);
            this.previewImage.src = url;
            this.close();
        }, 'image/jpeg', 0.8);
    }

    async generateFormData(formData) {
        const speakers = await Promise.all(
            Array.from(this.list.querySelectorAll('li')).map(async li => {
                const imageInput = li.querySelector('input[type="file"]');
                const imageFile = li.getElementsByTagName('img')[0]?.getAttribute('src');
                let fileBase64 = '';
    
                if (imageFile) {
                    try {
                        const blob = await this.getBlobFromUrl(imageFile);
                        const file = new File([blob], 'example.jpg', { type: blob.type });
                        fileBase64 = await this.toBase64(file)
                    } catch (error) {
                        console.error('Error fetching or converting image:', error);
                    }
                }
    
                return {
                    id: li.dataset.id,
                    position: li.querySelector('input[type="text"]').value,
                    profileImage: btoa(unescape(encodeURIComponent(fileBase64)))
                };
            })
        );
    
        speakers.forEach((speaker, index) => {
            formData.append(`speakers[${index}][id]`, speaker.id);
            formData.append(`speakers[${index}][position]`, speaker.position);
            
            if (speaker.profileImage) {
                formData.append(`speakers[${index}][profileImage]`, speaker.profileImage);
            }
        });
    }

    toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    });
}

export default ImageCropperModal;